import add from '@/assets/overview/add.png';
import build from '@/assets/overview/build.png';
import create from '@/assets/overview/create.png';
import debugging from '@/assets/overview/debugging.png';
import download from '@/assets/overview/download.png';
import release from '@/assets/overview/release.png';
import submit from '@/assets/overview/submit.png';
import disabled1 from '@/assets/overview/disabled1.svg';
import disabled2 from '@/assets/overview/disabled2.svg';
import $i18n from '@/i18n';

export const stepConfig = [
  {
    key: '01',
    title: $i18n.get({ id: 'aopf.pages.overview.Create.Miniapp', dm: '创建应用' }),
    imgUrlAdmin: create,
    imgUrlDeveloper: disabled1,
  },
  {
    key: '02',
    title: $i18n.get({ id: 'aopf.pages.overview.Add.Members', dm: '添加成员' }),
    imgUrlAdmin: add,
    imgUrlDeveloper: disabled2,
  },
  {
    key: '03',
    title: $i18n.get({ id: 'aopf.pages.overview.Download.IDE', dm: '下载IDE' }),
    imgUrlAdmin: download,
    imgUrlDeveloper: download,
  },
  {
    key: '04',
    title: $i18n.get({ id: 'aopf.pages.overview.Debugging', dm: '开发调试' }),
    imgUrlAdmin: debugging,
    imgUrlDeveloper: debugging,
  },
  {
    key: '05',
    title: $i18n.get({ id: 'aopf.pages.overview.Build.New.Version', dm: '构建' }),
    imgUrlAdmin: build,
    imgUrlDeveloper: build,
  },
  {
    key: '06',
    title: $i18n.get({ id: 'aopf.pages.overview.Choose.Channels', dm: '选渠道发版本' }),
    imgUrlAdmin: submit,
    imgUrlDeveloper: submit,
  },
  {
    key: '07',
    title: $i18n.get({ id: 'aopf.pages.overview.Release', dm: '正式发布' }),
    imgUrlAdmin: release,
    imgUrlDeveloper: release,
  },
];

/**
 * 部署到新加坡环境的文档链接
 */
// export const linkToDocument = {
//   ide: {
//     en: 'https://superapp.emas-poc.com/?lang=en#/resource',
//     zh: 'https://superapp.emas-poc.com/?lang=zh#/resource',
//   },
//   debugging: {
//     en: 'https://superapp.emas-poc.com/?lang=en#/document/localization-development-debugging',
//     zh: 'https://superapp.emas-poc.com/?lang=zh#/document/localization-development-debugging',
//   },
//   build: {
//     en: 'https://superapp.emas-poc.com/?lang=en#/document/build-and-upload-versions',
//     zh: 'https://superapp.emas-poc.com/?lang=zh#/document/build-and-upload-versions',
//   },
//   approval: {
//     en: 'https://superapp.emas-poc.com/?lang=en#/document/application-version-release',
//     zh: 'https://superapp.emas-poc.com/?lang=zh#/document/application-version-release',
//   },
//   release: {
//     en: 'https://superapp.emas-poc.com/?lang=en#/document/release-version',
//     zh: 'https://superapp.emas-poc.com/?lang=zh#/document/release-version',
//   },
// };

/**
 * 部署到客户环境的文档链接
 */
// TODO 需求链接 https://aliyuque.antfin.com/e2intl/fogqu1/zckwevr4egma9vka
export const linkToDocument = {
  ide: {
    // OLD
    // en: '/portal?lang=en#/resource',
    // zh: '/portal?lang=zh#/resource',
    // NEW
    en: '//www.alibabacloud.com/help/superapp/superapp-bap-public-intl/installing-the-plug-in',
    zh: '//www.alibabacloud.com/help/superapp/superapp-bap-public-intl/installing-the-plug-in',
  },
  debugging: {
    // en: '//www.alibabacloud.com/help/en/superapp/latest/localization-development-debugging-1',
    // zh: '//www.alibabacloud.com/help/zh/superapp/latest/localization-development-debugging-1',
    // OLD
    // en: '/portal?lang=en#/document/superapp/superapp-bap-public-intl/localization-development-debugging-1',
    // zh: '/portal?lang=zh#/document/superapp/superapp-bap-public-intl/localization-development-debugging-1',
    // NEW
    en: '//www.alibabacloud.com/help/superapp/latest/localization-development-debugging-1',
    zh: '//www.alibabacloud.com/help/superapp/latest/localization-development-debugging-1',
  },
  build: {
    // en: '//www.alibabacloud.com/help/en/superapp/latest/build-and-upload-versions',
    // zh: '//www.alibabacloud.com/help/zh/superapp/latest/build-and-upload-versions',
    // OLD
    // en: '/portal?lang=en#/document/superapp/superapp-bap-public-intl/build-and-upload-versions',
    // zh: '/portal?lang=zh#/document/superapp/superapp-bap-public-intl/build-and-upload-versions',
    // NEW
    en: '//www.alibabacloud.com/help/superapp/latest/build-and-upload-versions',
    zh: '//www.alibabacloud.com/help/superapp/latest/build-and-upload-versions',
  },
  approval: {
    // en: '//www.alibabacloud.com/help/en/superapp/latest/application-version-release-2?spm=a2c63.p38356.0.0.212738f6mt3WZw',
    // zh: '//www.alibabacloud.com/help/zh/superapp/latest/application-version-release-2?spm=a2c63.p38356.0.0.212738f6mt3WZw',
    // OLD
    // en: '/portal?lang=en#/document/superapp/superapp-bap-public-intl/application-version-release-2',
    // zh: '/portal?lang=zh#/document/superapp/superapp-bap-public-intl/application-version-release-2',
    // NEW
    en: '//www.alibabacloud.com/help/superapp/latest/application-version-release-2',
    zh: '//www.alibabacloud.com/help/superapp/latest/application-version-release-2',
  },
  release: {
    // en: '//www.alibabacloud.com/help/en/superapp/latest/release-version',
    // zh: '//www.alibabacloud.com/help/zh/superapp/latest/release-version',
    // OLD
    // en: '/portal?lang=en#/document/superapp/superapp-bap-public-intl/release-version',
    // zh: '/portal?lang=zh#/document/superapp/superapp-bap-public-intl/release-version',
    // NEW
    en: '//www.alibabacloud.com/help/superapp/latest/release-version',
    zh: '//www.alibabacloud.com/help/superapp/latest/release-version',
  },
};
